<template>
    <div>
        <nav-bar />
        <div class="main">
            <banner />
            <join />
            <site-footer />
        </div>
    </div>
</template>

<script>
import NavBar from "../views/commons/NavBar";
import Banner from "../views/joinPage/Banner";
import join from "../views/joinPage/join";
import SiteFooter from "../views/index-five/SiteFooter";

export default {
    name: "DownloadPage",
    components: {
        NavBar,
        Banner,
        join,
        SiteFooter,
    },
};
</script>

